/**
 * CategoryManagement object represents category management-related API endpoints and their methods.
 */
const CategoryManagement = {
  /**
   * Endpoint for retrieving all category.
   * @memberof CategoryManagement
   * @type {object}
   * @property {string} url - The URL for retrieving all category.
   * @property {string} method - The HTTP method for retrieving all category (GET).
   */
  getCategoryList: {
    url: "/category",
    method: "GET",
  },

  /**
   * Endpoint for adding a category.
   * @memberof CategoryManagement
   * @type {object}
   * @property {string} url - The URL for adding an category.
   * @property {string} method - The HTTP method for adding an category (POST).
   */

  addCategory: {
    url: "/category",
    method: "POST",
  },

  /**
   * Endpoint for deleting a specific Category by ID.
   * @memberof CategoryManagement
   * @function deleteCategory
   * @param {string} id - The ID of the Category to be deleted.
   * @returns {object} The endpoint object containing URL and method.
   */
  deleteCategory: (id) => ({
    url: `/category/${id}`,
    method: "DELETE",
  }),

  /**
   * Endpoint for retrieving a specific category by ID.
   * @memberof CategoryManagement
   * @function getSingleCategory
   * @param {string} id - The ID of the category to retrieve.
   * @returns {object} The endpoint object containing URL and method.
   */
  getSingleCategory: (id) => ({
    url: `/category/${id}`,
    method: "GET",
  }),

    /**
   * Endpoint for updating a specific Category by ID.
   * @memberof CategoryManagement
   * @function updateCategory
   * @param {string} id - The ID of the Category to update.
   * @returns {object} The endpoint object containing URL and method.
   */
    updateCategory: (id) => ({
      url: `/category/${id}`,
      method: "PUT",
    }),
    /**
   * Endpoint for updating a specific Category status by ID.
   * @memberof CategoryManagement
   * @function updateCategory
   * @param {string} id - The ID of the Category to update status.
   * @returns {object} The endpoint object containing URL and method.
   */
    updateCategoryStatus: (id) => ({
      url: `/category/${id}`,
      method: "PATCH",
    }),
};

// Export the CategoryManagement object for use in other modules
export default CategoryManagement;
